import styled from 'styled-components';

export const GameListWrapper = styled.div`
  display: flex;
  flex: 1;
  height: 100%;
  margin-top: 2rem;
  padding-bottom: 2rem;

  @media only screen and (max-height: 600px) {
    margin-top: 6rem;
  }

  @media only screen and (max-height: 880px) and (max-width: 1300px) {
    margin-left: 3rem;
  }

  ${({ theme }) => theme.Home.GameListWrapper}
`;

export const GameListContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  height: 92%;
  flex: 2.5;
  margin-top: 2.5rem;
  width: 100%;
  justify-content: center;

  @media only screen and (min-width: 1200px) and (max-width: 1350px) and (min-height: 900px) and (max-height: 1020px) {
    height: 72%;
    margin-top: 8.5rem;
  }

  @media only screen and (max-height: 600px) {
    margin-top: -0.5rem;
    height: 100%;
  }

  ${({ theme }) =>
    theme.platform('android') &&
    theme.screens.devices(['mobile-browser', 'mobile-standalone']) &&
    `
    height: 100%;
  `}
`;

